import component from './component';

export default component;


/** WEBPACK FOOTER **
 ** ./src/components/CardHolder/index.js
 **/